import { useMemo } from "react";
import { useAuth } from "./useAuth";
import { getUserModules } from "../utils/navigationUtils";

/**
 * Hook to check if user has view permission for a module
 */
export const useHasModulePermission = (module: string): boolean => {
  const { profile } = useAuth();

  return useMemo(() => {
    if (!profile || !Array.isArray(profile.permissions)) return false;
    const userModules = getUserModules(profile.permissions);
    return userModules.has(module);
  }, [profile, module]);
};

/**
 * Hook to get permission checks for multiple modules at once
 */
export const useModulePermissions = (
  modules: string[]
): Record<string, boolean> => {
  const { profile } = useAuth();

  return useMemo(() => {
    if (!profile || !Array.isArray(profile.permissions)) {
      return modules.reduce((acc, module) => {
        acc[module] = false;
        return acc;
      }, {} as Record<string, boolean>);
    }

    const userModules = getUserModules(profile.permissions);
    return modules.reduce((acc, module) => {
      acc[module] = userModules.has(module);
      return acc;
    }, {} as Record<string, boolean>);
  }, [profile, modules]);
};
